var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"event-list-view"},[_c('h1',[_vm._v(" Список зарегистрированных гостей ")]),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm._onXlsBtnClick}},[_vm._v(" Скачать xls ")]),_c('online-event-participant-list')],1)}
var staticRenderFns = []

export { render, staticRenderFns }